import Vue from 'vue'
// import './plugins/element.js'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

import './plugins/utils'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import './assets/scss/index.scss'

import VueBus from './plugins/vue-bus'

import './api/index'


Vue.use(VueBus)
